import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import { useParams } from "react-router";
import { FaEdit } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
import { FaTrash } from "react-icons/fa6";
import { Form, Table } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import Swal from "sweetalert2";
import Moment from "react-moment";
import Pagination from "../../Pagination";
import UseToggle from "../../../Hooks/UseToggle";
import PullCLookupMetadata from "./PullCLookupMetadata";
import AddNewCLookupMetadata from "./AddNewCLookupMetadata";
import UpdateCLookupMetadata from "./UpdateCLookupMetadata";
import DeletedCLookupMetadata from "./DeletedCLookupMetadata";
import TableProperties from "./Properties/TableProperties";
import CLookupMetadataActivities from "./Properties/CLookupMetadataActivities";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import ImportCLookupData from "./Properties/ImportCLookupData";

const CLookupManagement = ({ onMouseDown, tableRef }) => {
  const toggles = UseToggle();
  const { studyId } = useParams();
  const [loader, setLoader] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [cLookupMetadata, setCLookupMetadata] = useState([]);
  const [cLookupMetadataCount, setCLookupMetadataCount] = useState(0);
  const [cLookupData, setCLookupData] = useState("");
  const [isFormOpen, setIsFormOpen] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [cLookupId, setCLookupId] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [tableColumns, setTableColumns] = useState({});
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const formColumn = [
    {
      columnLabel: "Mapping Group",
      columnName: "MAPPINGGROUP",
      columnType: "text",
    },
    {
      columnLabel: "Domain",
      columnName: "DOMAIN",
      columnType: "text",
    },
    {
      columnLabel: "Test CD",
      columnName: "TESTCD",
      columnType: "text",
    },
    {
      columnLabel: "Source Unit",
      columnName: "SOURCEUNIT",
      columnType: "text",
    },
    {
      columnLabel: "Target Unit",
      columnName: "TARGETUNIT",
      columnType: "text",
    },
    {
      columnLabel: "Factor",
      columnName: "FACTOR",
      columnType: "text",
    },
    {
      columnLabel: "Afine Scale",
      columnName: "AFINESCALE",
      columnType: "text",
    },
    {
      columnLabel: "Afine Shift",
      columnName: "AFINESHIFT",
      columnType: "text",
    },
    {
      columnLabel: "Formula",
      columnName: "FORMULA",
      columnType: "text",
    },
    {
      columnLabel: "Created Date | Time",
      columnName: "CREATED",
      columnType: "date & time",
    },
    {
      columnLabel: "Updated Date | Time",
      columnName: "UPDATED",
      columnType: "date & time",
    },
    { columnLabel: "Edit", columnName: "EDIT", columnType: "action" },
    { columnLabel: "Delete", columnName: "DELETE", columnType: "action" },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(cLookupMetadataCount / itemsPerPage);

  const getStudyCDISCCLookUp = async () => {
    setLoader(true);
    let data = await cdiscManagementService.getStudyCDISCCLookUp(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setCLookupMetadata(data?.data || []);
    setCLookupMetadataCount(data?.count || 0);
    setLoader(false);
  };
  
  const downloadCLookUpTemplate = async () => {
    let data = await cdiscManagementService.downloadCLookUpTemplate();
    const csvContent = (data?.data || []).join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "CLookup-Template.csv";
    link.click();
  };

  useEffect(() => {
    getStudyCDISCCLookUp();
  }, [studyId, searchData, pageNumber, itemsPerPage]);

  const updateCLookupModal = (item) => {
    setCLookupData(item);
    toggles.setToggle();
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);
  const [deletedCLookupCount, setDeletedCLookupCount] = useState(0);
  const [deletedCLookup, setDeletedCLookup] = useState([]);

  const getDeletedCLookupList = async () => {
    let data = await cdiscManagementService.getStudyCDISCCLookUp(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedCLookup(data?.data || []);
    setDeletedCLookupCount(data?.count || 0);
  };

  const softDeleteRestoreStudyCDISCCLookUps = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} clookups!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data =
          await cdiscManagementService.softDeleteRestoreStudyCDISCCLookUps(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyCDISCCLookUp();
          getDeletedCLookupList();
          setCLookupId("");
          if (type === "restore") {
            getDeletedCLookupList(pageNumberDeleted, itemsPerPageDeleted);
            toggles.setToggle1();
          }
        }
      }
    });
  };

  const [formActivity, setFormActivity] = useState([]);
  const [formActivityCount, setFormActivityCount] = useState(0);
  const [activityLoader, setActivityLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudyCDISCAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyCDISCAuditTrials(
      "CDISCCLookUpMetadata",
      studyId,
      cLookupData?.lookUpId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setFormActivity(data?.data || []);
    setFormActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getGlobalTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getGlobalTablePropertiesData(
      "cdiscControlTerm"
    );
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getGlobalTablePropertiesData();
  }, []);

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to update table property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.type = "cdiscControlTerm";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyCDISCCLookUp();
          getGlobalTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add CLookup Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setCLookupId("");
            }}
            className={`fa-solid ${
              isFormOpen ? "fa-table-list" : "fa-plus-square CP"
            }`}
          />
          <div className="vr"></div>
          {cLookupMetadataCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "5px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 5, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <button
            onClick={() => toggles.setToggle4()}
            className={`updateProfile`}
            style={{ fontSize: 12 }}
          >
            Import
          </button>
          <button
            onClick={() => toggles.setToggle3()}
            className={`updateProfile`}
            style={{ fontSize: 12 }}
          >
            Pull Metadata
          </button>
          {cLookupMetadataCount > 0 && (
            <button
              onClick={() => toggles.setToggle2()}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
          {deletedCLookupCount > 0 && (
            <button
              onClick={() => toggles.setToggle1()}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={cLookupId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && (
            <AddNewCLookupMetadata
              studyId={studyId}
              getStudyCDISCCLookUp={getStudyCDISCCLookUp}
            />
          )}
          {loader ? (
            <PageLoader />
          ) : cLookupMetadata?.length === 0 ? (
            <NoDataFoundTable MSG={"CLookup metadata not found!"} />
          ) : (
            <>
              <Table
                ref={tableRef}
                className="m-0 custom-table custom-tables"
                hover
                striped
              >
                <thead className="position-sticky top-0">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    {!tableColumns["MAPPINGGROUP"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Mapping Group</th>
                    )}
                    {!tableColumns["DOMAIN"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Domain</th>
                    )}
                    {!tableColumns["TESTCD"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Test CD</th>
                    )}
                    {!tableColumns["SOURCEUNIT"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Source Unit</th>
                    )}
                    {!tableColumns["TARGETUNIT"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Target Unit</th>
                    )}
                    {!tableColumns["FACTOR"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 6)}>Factor</th>
                    )}
                    {!tableColumns["AFINESCALE"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 7)}>Afine Scale</th>
                    )}
                    {!tableColumns["AFINESHIFT"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 8)}>Afine Shift</th>
                    )}
                    {!tableColumns["FORMULA"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 9)}>Formula</th>
                    )}
                    {!tableColumns["CREATED"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 10)}
                        style={{ width: 180 }}
                      >
                        Created Date | Time
                      </th>
                    )}
                    {!tableColumns["UPDATED"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 11)}
                        style={{ width: 180 }}
                      >
                        Updated Date | Time
                      </th>
                    )}
                    {!tableColumns["EDIT"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 12)}
                        style={{ width: 45 }}
                        className="text-center"
                      >
                        Edit
                      </th>
                    )}
                    {!tableColumns["DELETE"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 13)}
                        style={{ width: 55 }}
                        className="text-center"
                      >
                        Delete
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {cLookupMetadata?.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => {
                        setIsFormOpen(false);
                        setCLookupId(item?.lookUpId);
                        setCLookupData(item);
                      }}
                      className={`CP ${
                        cLookupId === item?.lookUpId ? "highlighted" : ""
                      }`}
                      title="View Details"
                    >
                      <td className="text-center">{startIndex + index + 1}</td>
                      {!tableColumns["MAPPINGGROUP"] && <td>{item.mappingGroup}</td>}
                      {!tableColumns["DOMAIN"] && <td>{item.domain}</td>}
                      {!tableColumns["TESTCD"] && <td>{item.testCD}</td>}
                      {!tableColumns["SOURCEUNIT"] && <td>{item.sourceUnit}</td>}
                      {!tableColumns["TARGETUNIT"] && <td>{item.targetUnit}</td>}
                      {!tableColumns["FACTOR"] && <td>{item.factor}</td>}
                      {!tableColumns["AFINESCALE"] && <td>{item.afineScale}</td>}
                      {!tableColumns["AFINESHIFT"] && <td>{item.afineShift}</td>}
                      {!tableColumns["FORMULA"] && <td>{item.formula}</td>}
                      {!tableColumns["CREATED"] && (
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.createdAt}
                          </Moment>
                        </td>
                      )}
                      {!tableColumns["UPDATED"] && (
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.updatedAt}
                          </Moment>
                        </td>
                      )}
                      {!tableColumns["EDIT"] && (
                        <td
                          className="text-center CP"
                          title="Update"
                          onClick={(e) => {
                            updateCLookupModal(item);
                            e.stopPropagation();
                          }}
                        >
                          <FaEdit className="text-muted" />
                        </td>
                      )}
                      {!tableColumns["DELETE"] && (
                        <td
                          className="text-center CP"
                          title="Delete"
                          onClick={(e) => {
                            softDeleteRestoreStudyCDISCCLookUps(
                              item._id,
                              "delete"
                            );
                            e.stopPropagation();
                          }}
                        >
                          <FaTrash className="text-danger" />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={cLookupMetadataCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {cLookupId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${
                      activeTab === tab ? "activee" : ""
                    }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCLookupId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${
                      !isFullScreen ? "fa-maximize" : "fa-minimize"
                    }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={() => setIsFullScreen(!isFullScreen)}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <CLookupMetadataActivities
                tableRef={tableRef}
                onMouseDown={onMouseDown}
                formActivity={formActivity}
                cLookupData={cLookupData}
                activityLoader={activityLoader}
                formActivityCount={formActivityCount}
                getStudyCDISCAuditTrials={getStudyCDISCAuditTrials}
              />
            )}
          </div>
        )}
      </SplitPane>
      <UpdateCLookupMetadata
        studyId={studyId}
        cLookupData={cLookupData}
        getStudyCDISCCLookUp={getStudyCDISCCLookUp}
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Update CLookups"}
      />
      <DeletedCLookupMetadata
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        setCLookupId={setCLookupId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedCLookup={deletedCLookup}
        getDeletedCLookupList={getDeletedCLookupList}
        deletedCLookupCount={deletedCLookupCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreStudyCDISCCLookUps={softDeleteRestoreStudyCDISCCLookUps}
        Title={"Deleted CLookups History"}
      />
      <TableProperties
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        buttonLoader={buttonLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />

      <PullCLookupMetadata
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        studyId={studyId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        getStudyCDISCCLookUp={getStudyCDISCCLookUp}
        Title="Pull CLookups"
      />
      <ImportCLookupData
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        studyId={studyId}
        Title={"Import CLookup Data"}
        getStudyCDISCCLookUp={getStudyCDISCCLookUp}
        downloadCLookUpTemplate={downloadCLookUpTemplate}
      />
    </>
  );
};

export default CLookupManagement;
